import { Lock } from 'lucide-react';

import { useUsuario } from '@/lib/auth/contexto';
import { podeEmAlguma } from '@/lib/auth/permissoes';
import { useEscopoEmpresas } from '@/lib/escopo';
import { EstadoVazio } from '@/ui/components/estado-vazio';
import { CabecalhoPagina } from '@/ui/patterns/cabecalho-pagina';

import { CartaoPlanilha } from './cartao-planilha';

export function PaginaRelatorios() {
  const usuario = useUsuario();
  const escopo = useEscopoEmpresas();
  return (
    <div className="grid content-start gap-6">
      <CabecalhoPagina
        titulo="Relatórios"
        descricao="Arquivos gerados a partir das notas importadas, prontos para a contabilidade."
      />
      {podeEmAlguma(usuario, 'relatorios.ler') ? (
        <div className="grid gap-4 lg:grid-cols-2">
          <CartaoPlanilha empresaIds={escopo} />
        </div>
      ) : (
        <EstadoVazio
          icone={<Lock />}
          titulo="Sem acesso aos relatórios"
          texto="Peça a quem administra o sistema para liberar os relatórios no seu perfil."
        />
      )}
    </div>
  );
}
